import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_CSAT_COUNT, SUPERSET_CSAT_COUNT_ERROR, SUPERSET_CSAT_COUNT_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetCSATCount({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_CSAT_COUNT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_CSAT_COUNT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_CSAT_COUNT_ERROR, payload: error });
  }
}

export function* watchSupersetCSATCount() {
  yield takeEvery(SUPERSET_CSAT_COUNT, supersetCSATCount);
}

function* supersetCSATCountSaga() {
  yield all([fork(watchSupersetCSATCount)]);
}

export default supersetCSATCountSaga;
